import { render, staticRenderFns } from "./invoiceView.vue?vue&type=template&id=5c476b4c&scoped=true"
import script from "./invoiceView.vue?vue&type=script&lang=js"
export * from "./invoiceView.vue?vue&type=script&lang=js"
import style0 from "./invoiceView.vue?vue&type=style&index=0&id=5c476b4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c476b4c",
  null
  
)

export default component.exports